import { Layout } from "Layout";
import BlockReason from "pages/DataManagement/BlockReason";
import React, { lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";

//Pages
const AdminDashbord = lazy(() => import("pages/Dashboard"));
const AnnouncementPage = lazy(() => import("pages/AnnouncementPage"));
const UserPage = lazy(() => import("pages/Users"));
const UserDetailPage = lazy(() => import("pages/Users/UserDetail"));
const ComingSoon = lazy(() => import("pages/ComingSoon"));
const RolesAdd = lazy(() => import("pages/MembersAndRoles/Roles/RolesAdd"));
const RolesEdit = lazy(() => import("pages/MembersAndRoles/Roles/RolesEdit"));
const AddTeamMember = lazy(
  () => import("pages/MembersAndRoles/TeamMembers/AddTeamMember"),
);
const EditTeamMember = lazy(
  () => import("pages/MembersAndRoles/TeamMembers/EditTeamMember"),
);
const TeamMembers = lazy(() => import("pages/MembersAndRoles/TeamMembers"));
const AdminProfile = lazy(() => import("pages/AdminProfile/Profile"));
const AdminChangePass = lazy(() => import("pages/AdminProfile/ChangePass"));
const TermAndCondition = lazy(() => import("pages/CMS/TermAndCondition"));
const PrivacyPolicy = lazy(() => import("pages/CMS/PrivacyPolicy"));
const DataDeletions = lazy(() => import("pages/CMS/DataDelation"));
const AdminSettings = lazy(() => import("pages/Settings"));
const Permission = lazy(() => import("pages/MembersAndRoles/Permission"));
const AddPermission = lazy(
  () => import("pages/MembersAndRoles/Permission/AddPermission"),
);
const Roles = lazy(() => import("pages/MembersAndRoles/Roles"));
const ForgetPassword = lazy(() => import("pages/ForgetPassword"));
const Error404 = lazy(() => import("pages/ErrorPages/Error404"));
const ResetPassSuccessfully = lazy(() => import("pages/ResetPassSuccessfully"));
const ResetPasswordAdmin = lazy(() => import("pages/ResetPasswordAdmin"));
const AdminLogin = lazy(() => import("pages/Login/Login"));
const Country = lazy(() => import("pages/DataManagement/Country"));
const Language = lazy(() => import("pages/DataManagement/Language"));
const Currency = lazy(() => import("pages/DataManagement/Currency"));
const Hobby = lazy(() => import("pages/DataManagement/Hobby"));
const Employment = lazy(() => import("pages/DataManagement/Employment"));
const Personality = lazy(() => import("pages/DataManagement/Personality"));
const Culture = lazy(() => import("pages/DataManagement/Culture"));
const Relationship = lazy(() => import("pages/DataManagement/Relationship"));
const Sect = lazy(() => import("pages/DataManagement/Sect"));
const ReportReason = lazy(() => import("pages/DataManagement/ReportReason"));
const ChatReport = lazy(() => import("pages/ChatReport"));
const UserReportReason = lazy(
  () => import("pages/DataManagement/UserReportReason"),
);
const MaliciousWords = lazy(
  () => import("pages/DataManagement/MaliciousWords"),
);
const DeleteReason = lazy(() => import("pages/DataManagement/DeleteReason"));
const UserSubscriptionPlan = lazy(
  () => import("pages/DataManagement/UserPlan"),
);
const AddPlan = lazy(() => import("pages/DataManagement/UserPlan/AddPlan"));
const MaliciousReports = lazy(() => import("pages/MaliciousReports"));
const GuardianDetails = lazy(() => import("pages/Users/GuardianDetails"));
const AnnouncementUserList = lazy(
  () => import("pages/AnnouncementPage/UserList"),
);
const AuthPrivacyPolicyPage = lazy(() => import("pages/AuthPrivacyPolicyPage"));
const PlanHistory = lazy(() => import("pages/PlanHistory"));

const basePath = "";

const generatePath = (slug) => {
  return `${basePath}/${slug}`;
};

export const adminRoutes = [
  {
    path: generatePath("/dashboard"),
    element: <AdminDashbord />,
    title: "Dashboard",
  },
  {
    path: generatePath("/announcement"),
    element: <AnnouncementPage />,
    title: "Announcements",
  },
  {
    path: generatePath("/announcement/:id"),
    element: <AnnouncementUserList />,
    title: "Announcement Users",
  },
  {
    path: generatePath("account/home/get-started"),
    element: <AdminDashbord />,
    title: "Dashboard",
  },
  {
    path: generatePath("account/home/user-profile"),
    element: <AdminSettings />,
    title: "Settings",
  },
  {
    path: generatePath("error-404"),
    element: <Error404 />,
  },
  {
    path: generatePath("settings"),
    element: <AdminSettings />,
    title: "Settings",
  },
  {
    path: generatePath("terms"),
    element: <TermAndCondition />,
    title: "Terms And Conditions",
  },
  {
    path: generatePath("data-deletions"),
    element: <DataDeletions />,
    title: "Data Deletions",
  },
  {
    path: generatePath("privacy"),
    element: <PrivacyPolicy />,
    title: "Privacy Policy",
  },
  {
    path: generatePath("/public-profile/profile"),
    element: <AdminProfile />,
    title: "My Profile",
  },
  {
    path: generatePath("/public-profile/change-password"),
    element: <AdminChangePass />,
    title: "Change Password",
  },
  {
    path: generatePath("/access-management/permission"),
    element: <Permission />,
    title: "Permission",
  },
  {
    path: generatePath("/access-management/permission/addEdit-permission"),
    element: <AddPermission />,
    title: "Add Permission",
  },
  {
    path: generatePath("/access-management/team-members/add-team-members"),
    element: <AddTeamMember />,
    title: "Add TeamMember",
  },
  {
    path: generatePath("/access-management/team-members/edit-team-members"),
    element: <EditTeamMember />,
    title: "Edit TeamMember",
  },
  {
    path: generatePath("/access-management/roles"),
    element: <Roles />,
    title: "Roles",
  },
  {
    title: "Team Members",
    path: generatePath("/access-management/team-members"),
    element: <TeamMembers />,
  },
  {
    title: "Add Roles",
    path: generatePath("/access-management/roles/add"),
    element: <RolesAdd />,
  },
  {
    title: "Edit Role",
    path: generatePath("/access-management/roles/edit/:id"),
    element: <RolesEdit />,
  },
  {
    title: "Country",
    path: generatePath("/data-management/country"),
    element: <Country />,
  },
  {
    title: "Language",
    path: generatePath("/data-management/language"),
    element: <Language />,
  },
  {
    title: "Currency",
    path: generatePath("/data-management/currency"),
    element: <Currency />,
  },
  {
    title: "Hobby",
    path: generatePath("/data-management/hobby"),
    element: <Hobby />,
  },
  {
    title: "Employment",
    path: generatePath("/data-management/employment"),
    element: <Employment />,
  },
  {
    title: "Personality",
    path: generatePath("/data-management/personality"),
    element: <Personality />,
  },
  {
    title: "Culture",
    path: generatePath("/data-management/culture"),
    element: <Culture />,
  },
  {
    title: "Relationship",
    path: generatePath("/data-management/relationship"),
    element: <Relationship />,
  },
  {
    title: "Sect",
    path: generatePath("/data-management/sect"),
    element: <Sect />,
  },
  {
    title: "Chat Report Reason",
    path: generatePath("/data-management/report-reason"),
    element: <ReportReason />,
  },
  {
    title: "User Report Reason",
    path: generatePath("/data-management/user-report-reason"),
    element: <UserReportReason />,
  },
  {
    title: "Malicious Words",
    path: generatePath("/data-management/malicious-words"),
    element: <MaliciousWords />,
  },
  {
    title: "Malicious Reports",
    path: generatePath("/malicious-reports"),
    element: <MaliciousReports />,
  },
  {
    title: "User Subscription",
    path: generatePath("/data-management/user-plans"),
    element: <UserSubscriptionPlan />,
    id: "user_plans",
  },
  {
    title: "Add Subscription plan",
    path: generatePath("/data-management/user-plans/add-plan"),
    element: <AddPlan />,
    id: "add_Plan",
  },
  {
    title: "Edit Subscription plan",
    path: generatePath("/data-management/user-plans/edit-plan"),
    element: <AddPlan />,
    id: "edit_Plan",
  },
  {
    title: "Delete Reason",
    path: generatePath("/data-management/delete-reason"),
    element: <DeleteReason />,
    id: "delete_reason",
  },
  {
    title: "Block Reason",
    path: generatePath("/data-management/block-reason"),
    element: <BlockReason />,
    id: "block_reason",
  },

  {
    title: "Users",
    path: generatePath("/users"),
    element: <UserPage />,
    id: "users",
  },
  {
    title: "Chat Report",
    path: generatePath("/users/chat/:id"),
    element: <ChatReport />,
    id: "chat_report",
  },
  {
    title: "User Details",
    path: generatePath("/users/details/:id"),
    element: <UserDetailPage />,
    id: "userDetail",
  },
  {
    title: "Guardian Details",
    path: generatePath("/users/details/:userId/guardian/details/:id"),
    element: <GuardianDetails />,
    id: "guardian_Details",
  },
  {
    title: "Subscription History",
    path: generatePath("/subscription-history"),
    element: <PlanHistory />,
    id: "subscriptionHistory",
  },
];

const adminAuthRoutes = [
  {
    path: generatePath("/forget-password"),
    element: <ForgetPassword />,
  },
  {
    path: generatePath("/resetpassword/successfully"),
    element: <ResetPassSuccessfully />,
  },
  {
    path: generatePath("/resetAdminPassword/:id"),
    element: <ResetPasswordAdmin />,
  },
  {
    path: generatePath("/admin"),
    element: <AdminLogin />,
  },
  // {
  //   path: generatePath("/privacy-policy"),
  //   element: <AuthPrivacyPolicyPage />,
  // },
  // {
  //   path: generatePath("/data-deletion"),
  //   element: <AuthPrivacyPolicyPage />,
  // },
  // {
  //   path: generatePath("/terms-and-conditions"),
  //   element: <AuthPrivacyPolicyPage />,
  // },
];

const publicAlwaysAccessibleRoutes = [
  {
    path: generatePath("/"),
    element: <ComingSoon />,
  },
  {
    path: generatePath("/privacy-policy"),
    element: <AuthPrivacyPolicyPage />,
  },
  {
    path: generatePath("/data-deletion"),
    element: <AuthPrivacyPolicyPage />,
  },
  {
    path: generatePath("/terms-and-conditions"),
    element: <AuthPrivacyPolicyPage />,
  },
];

const AdminNavigation = () => {
  const user = JSON.parse(localStorage.getItem("zaffa-admin"));

  return (
    <Routes>
      {/* if user is logged in redirect to dashboard */}
      {/* <Route
        path=""
        element={!user ? <AdminLogin /> : <Navigate to="/dashboard" />}
      /> */}
      {/* if user is not present show unauthorized ui */}
      {/* Always-accessible public routes (no redirect) */}
      {publicAlwaysAccessibleRoutes.map((route, index) => (
        <Route
          key={`public-${route.path}${index}`}
          path={route.path}
          element={route.element}
        />
      ))}

      {/* Protected routes – only when user is logged in */}
      <Route element={!user ? <Navigate to="/admin" /> : <Layout />}>
        {adminRoutes.map((route, index) => (
          <Route
            key={`${route.path}${index}`}
            path={route.path}
            element={route.element}
          />
        ))}
      </Route>

      {/* Auth routes – redirect to dashboard if user is logged in */}
      {adminAuthRoutes.map((route, index) => (
        <Route
          key={`${route.path}${index}`}
          path={route.path}
          element={user ? <Navigate to="/dashboard" replace /> : route.element}
        />
      ))}

      {/* Catch-all 404 route */}
      <Route
        path="*"
        element={!user ? <Navigate to="/admin" /> : <Error404 />}
      />
    </Routes>
  );
};

export default AdminNavigation;
